<template>
    <div>
        <div class="approvalTask-title">
            <div>{{$t('ApprovalTask.title')}}</div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('ApprovalTask.processing')">
                    <div class="approvalTask-top">
                        <approval-task-search></approval-task-search>
                    </div>
                </TabPane>
                <TabPane :label="$t('ApprovalTask.passed')">
                    <div class="approvalTask-top">
                        <approval-task-passed-search></approval-task-passed-search>
                    </div>
                </TabPane>
                <TabPane :label="$t('ApprovalTask.rejected')">
                    <div class="approvalTask-top">
                        <approval-task-dismissed-search></approval-task-dismissed-search>
                    </div>
                </TabPane>
                <TabPane :label="$t('ApprovalTask.expired')">
                  <div class="approvalCancel-top">
                    <approval-task-cancel-search></approval-task-cancel-search>
                  </div>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import ApprovalTaskSearch from '../approval_task/approval_task/ApprovalTaskSearch'
    import ApprovalTaskPassedSearch from '../approval_task/approval_task_passed/ApprovalTaskPassedSearch'
    import ApprovalTaskDismissedSearch from '../approval_task/approval_task_dismissed/ApprovalTaskDismissedSearch'
    import ApprovalTaskCancelSearch from '../approval_task/approval_task_cancel/ApprovalTaskCancelSearch'

    export default {
        name: 'ApprovalTask',
        components: {
            ApprovalTaskSearch,
            ApprovalTaskPassedSearch,
            ApprovalTaskDismissedSearch,
            ApprovalTaskCancelSearch
        }
    }
</script>

<style scoped>
    .approvalTask-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .approvalTask-title>div:nth-child(1)
    {
        float:left;
    }
    .approvalTask-top
    {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/approval_task/ApprovalTask.vue